import { isEmpty } from 'lodash';
import { createSelector } from 'reselect';
import { serviceSelector } from '../selector';
import { selectIsHpa } from '../hpa/selectors';
import { PlaceHolderIds } from '../../components/PagePlaceholder';
import { shouldShowPlaceholder } from '../../utils/Functions';
import { findByNotificationIdentity, isValue } from '../util';

export const selectShowServicePagePlaceholder = createSelector(
  [serviceSelector],
  (serviceSelector) => {
    let { isFetching, data, error } = serviceSelector.integrations;
    if (isFetching) {
      return PlaceHolderIds.LOADER;
    }
    let show = isEmpty(data) && error == null;
    return shouldShowPlaceholder(show, PlaceHolderIds.SERVICES);
  }
);

/**
 * Determine whether noona activation notification should be shown.
 *
 * Selects notification data for noona, and checks whether "showNotification" flag is true.
 *
 * @param   {array}   serviceNotifications The service integrations list returned from reducer.
 * @returns {boolean}                     Whether noona activation notification should be shown.
 * */
export const determineShowNoonaActivationNotification = (
  serviceNotifications
) => {
  // notification data is searched by matching id
  const noona = findByNotificationIdentity(
    serviceNotifications,
    'NOONA_PAGE_NOTIFICATION'
  );
  return isValue(noona);
};

export const selectNotification = (identifier, notifications) => {
  return findByNotificationIdentity(notifications, identifier);
};

export const notificationShouldBeVisible = (identifier) => (notifications) => {
  const _isValue = isValue(selectNotification(identifier, notifications));
  return _isValue;
};

export const notificationIsFetching = (identifier) => (notifications) => {
  let notification = selectNotification(identifier, notifications);
  const isFetching = isValue(notification) && notification.isFetching;
  return isFetching;
};
